import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import {
   BoxContainerLighter,
   H2,
   H3,
   Input,
   Label,
   TwoColumnContent
} from '@welcom/esg-react-components'
import { Statusbar } from '../components/Statusbar'
import { AppContext } from '../appState'
import { isValidEmail } from '../utils/validation'

const AlignLeft = styled.div`
   text-align: left;
`
const FlexContainer = styled.div`
   display: flex;
   margin: 40px 0 20px 0;

   h3 {
      margin-bottom: 0;
      margin-right: 20px;
   }
`

export const Guardians = () => {
   const { store, dispatch, setDisableNext } = useContext(AppContext)
   const [emails, setEmails] = useState({}) // object with array for emails, set with guardian index as key

   useEffect(() => {
      /* if email is set, add to email values */
      store.guardians.forEach((guardian, index) => {
         if (guardian.email) {
            updateEmails(store.guardians[index].email, index)
         }
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (
         store.guardians[0].name &&
         store.guardians[0].surname &&
         store.guardians[0].email
      ) {
         setDisableNext(false)
      } else {
         setDisableNext(true)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [store.guardians])

   const updateEmails = (value, index) => {
      let values = { ...emails }
      values[index] = value
      setEmails(values)
   }

   /**
    * Render Forms for guardians
    * @params index : int // Guardian number
    * @returns from
    */
   const renderForm = index => {
      return (
         <TwoColumnContent>
            <div>
               <Label
                  required={index === 0 ? true : false}
                  HtmlFor={'name' + index}
               >
                  First Name
               </Label>
               <Input
                  type={'text'}
                  id={'name' + index}
                  required={index === 0 ? true : false}
                  value={store.guardians[index].name ?? ''}
                  onChange={e => {
                     dispatch({
                        type: 'updateGuardian',
                        key: 'name',
                        guardian: index,
                        value: e.target.value
                     })
                  }}
               />
            </div>
            <div>
               <Label
                  required={index === 0 ? true : false}
                  HtmlFor={'surname' + index}
               >
                  Last Name
               </Label>
               <Input
                  type={'text'}
                  id={'surname' + index}
                  required={index === 0 ? true : false}
                  value={store.guardians[index].surname ?? ''}
                  onChange={e => {
                     dispatch({
                        type: 'updateGuardian',
                        key: 'surname',
                        guardian: index,
                        value: e.target.value
                     })
                  }}
               />
            </div>
            <div>
               <Label HtmlFor={'phoneMobile' + index}>Phone mobile</Label>
               <Input
                  type={'text'}
                  id={'phoneMobile' + index}
                  value={store.guardians[index].phoneMobile ?? ''}
                  onChange={e => {
                     dispatch({
                        type: 'updateGuardian',
                        key: 'phoneMobile',
                        guardian: index,
                        value: e.target.value
                     })
                  }}
               />
            </div>
            <div>
               <Label HtmlFor={'phoneHome' + index}>Phone home</Label>
               <Input
                  type={'text'}
                  id={'phoneHome' + index}
                  value={store.guardians[index].phoneHome ?? ''}
                  onChange={e => {
                     dispatch({
                        type: 'updateGuardian',
                        key: 'phoneHome',
                        guardian: index,
                        value: e.target.value
                     })
                  }}
               />
            </div>
            <div>
               <Label
                  HtmlFor={'email' + index}
                  required={index === 0 ? true : false}
               >
                  E-mail
               </Label>
               <Input
                  type={'email'}
                  id={'email' + index}
                  required={index === 0 ? true : false}
                  value={emails[index] || ''}
                  onChange={e => {
                     updateEmails(e.target.value, index)

                     isValidEmail(e.target.value)
                        ? dispatch({
                             type: 'updateGuardian',
                             key: 'email',
                             guardian: index,
                             value: e.target.value
                          })
                        : dispatch({
                             type: 'updateGuardian',
                             key: 'email',
                             guardian: index,
                             value: ''
                          })
                  }}
               />
            </div>
            <div>
               <Label HtmlFor={'address' + index}>Address</Label>
               <Input
                  type={'text'}
                  id={'address' + index}
                  value={store.guardians[index].address ?? ''}
                  onChange={e => {
                     dispatch({
                        type: 'updateGuardian',
                        key: 'address',
                        guardian: index,
                        value: e.target.value
                     })
                  }}
               />
            </div>
            <div>
               <Label HtmlFor={'postalCode' + index}>Postal code</Label>
               <Input
                  type={'text'}
                  id={'postalCode' + index}
                  value={store.guardians[index].postalCode ?? ''}
                  onChange={e => {
                     dispatch({
                        type: 'updateGuardian',
                        key: 'postalCode',
                        guardian: index,
                        value: e.target.value
                     })
                  }}
               />
            </div>
            <div>
               <Label HtmlFor={'city' + index}>City</Label>
               <Input
                  type={'text'}
                  id={'city' + index}
                  value={store.guardians[index].city ?? ''}
                  onChange={e => {
                     dispatch({
                        type: 'updateGuardian',
                        key: 'city',
                        guardian: index,
                        value: e.target.value
                     })
                  }}
               />
            </div>
         </TwoColumnContent>
      )
   }

   return (
      <AlignLeft>
         <BoxContainerLighter>
            <Statusbar currentStep={1} />
            <H2>2. Guardians information</H2>
            <p>Fields marked with an * are required.</p>

            <H3>Guardian 1</H3>
            {renderForm(0)}

            <FlexContainer>
               <H3>Guardian 2</H3>
            </FlexContainer>
            {renderForm(1)}
         </BoxContainerLighter>
      </AlignLeft>
   )
}
